import { useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys } from '../api/dashboard.api';

/**
 * Live team-activity feed. The elapsed timers tick client-side (see `useNow` in
 * the card); this query just refreshes the underlying running/last/attendance
 * data every 60s so new check-ins and started/stopped timers show up.
 */
export function useMDTeamActivity() {
  return useQuery({
    queryKey: dashboardQueryKeys.mdTeamActivity(),
    queryFn: () => dashboardApi.getMDTeamActivity(),
    refetchInterval: 60_000,
  });
}
